import { Component, ViewChild } from '@angular/core';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { NceService } from '../services/nce.service';
import { LayoutService } from '../../shared/services/layout.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { StorageService } from '../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'nce-briefing-document',
    templateUrl: '../../shared/components/preview/preview-parent.component.html'
})
export class NceBriefingDocumentComponent{

    vNCEid = this._nceService.getNCEID().nce_record_id;

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService,
        private _popupService: PopupService,
        private _errorService: ErrorService,
    ) { }


    ngOnInit() {
       this._layoutService.setCurrentPage('nce-briefing-document');
       this._nceService.loadDetailNCE(this._nceService.getNCEID().nce_record_id);
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    getDetailNCE(){
        return this._nceService.getDetailNCE();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/briefing-document.component.ts